import { isEmpty } from '@/utils/isEmpty';
import { useFormikContext } from 'formik';
import { FC, useEffect } from 'react';

export const PhoneVerificationAutoSubmit: FC = () => {
  const { submitForm, isValid, isValidating, touched, isSubmitting } = useFormikContext();

  useEffect(() => {
    if (isValid && !isValidating && !isEmpty(touched) && !isSubmitting) {
      submitForm();
    }
  }, [isValid, isValidating, submitForm, touched, isSubmitting]);

  return null;
};
